import configs from 'configs';
import { fetchWithTimeout } from 'functions/fetchWithTimeout';

const GET_REVERSE_GEOCODE_TIMEOUT = 2000;

// for historical reason
const DEFAULT_COUNTRY_LABEL = 'user location';

const reverseGeocode = async (latitude, longitude) => {
  const apiKey = configs.geosearchapi;
  const apiUrl = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;

  const response = await fetchWithTimeout({ resource: apiUrl, timeout: GET_REVERSE_GEOCODE_TIMEOUT });
  const data = await response.json();

  if (data.status.code !== 200) {
    return;
  }

  const result = data.results[0];

  // eslint-disable-next-line consistent-return
  return {
    address: result.formatted,
    country: result.components.country,
    state: result.components.state || null,
  };
};

const getBrowserPosition = (options) => new Promise(((resolve, reject) => {
  navigator.geolocation.getCurrentPosition(resolve, reject, options);
}));

export const requestUserCountry = async () => {
  if (!navigator.geolocation) {
    return;
  }
  let position;
  try {
    position = await getBrowserPosition();
  } catch (ex) {
    console.error('Can\'t get user browser position', ex);
    return;
  }
  if (!position?.coords?.latitude) {
    // invariant
    return;
  }

  const { coords: { latitude, longitude } } = position;

  let reverseGeocodeLocation;
  try {
    reverseGeocodeLocation = await reverseGeocode(latitude, longitude);
  } catch (ex) {
    console.error('Can\'t get reverse geocode location', ex);
  }

  if (!reverseGeocodeLocation) {
    // eslint-disable-next-line consistent-return
    return {
      label: DEFAULT_COUNTRY_LABEL,
      location: {
        lat: latitude,
        lng: longitude,
      },
    };
  }

  // eslint-disable-next-line consistent-return
  return {
    location: {
      lat: latitude,
      lng: longitude,
    },
    name: null,
    label: reverseGeocodeLocation.address,
    state: reverseGeocodeLocation.country,
  };
};
